/**
 * Navigation config for the shared <Sidenav> component.
 *
 * The Sidenav renders whatever item array it is given. Top-level pages use
 * `topLevelNav`; the website-detail pages use `websiteDetailNav(slug, pathname)`,
 * whose items are real routes (active state derived from the current pathname).
 */
import Icon from "@mui/material/Icon";

import { CONTENT_TYPE_KEYS, getContentType } from "config/contentTypeRegistry";

const navIcon = (name) => <Icon fontSize="small">{name}</Icon>;

// Items shown on top-level pages (Dashboard / Websites / Users).
export const topLevelNav = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: navIcon("dashboard"),
    route: "/dashboard",
  },
  {
    type: "collapse",
    name: "Websites",
    key: "websites",
    icon: navIcon("language"),
    route: "/websites",
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: navIcon("people"),
    route: "/users",
  },
];

// Items shown inside a single website (`/websites/:slug/...`). Every item is a
// real route; `active` is computed from the current pathname (Dashboard is an
// exact match, the rest match by prefix).
export const websiteDetailNav = (slug, pathname) => {
  const base = `/websites/${slug}`;

  const item = (name, key, icon, route, exact = false) => ({
    type: "collapse",
    name,
    key,
    icon: navIcon(icon),
    route,
    active: exact ? pathname === route : pathname.startsWith(route),
  });

  const contentChildren = CONTENT_TYPE_KEYS.map((typeKey) => {
    const entry = getContentType(typeKey);
    return item(entry.label, `content-${typeKey}`, entry.icon, `${base}/${typeKey}`);
  });

  return [
    item("Dashboard", "dashboard", "dashboard", base, true),
    {
      type: "collapse-group",
      name: "Content",
      key: "content",
      icon: navIcon("layers"),
      active: contentChildren.some((child) => child.active),
      children: contentChildren,
    },
    item("Categories", "categories", "folder", `${base}/categories`),
    item("Tags", "tags", "label", `${base}/tags`),
    item("Authors", "authors", "people", `${base}/authors`),
    item("Forms", "forms", "list_alt", `${base}/forms`),
    item("Email Templates", "email-templates", "mail", `${base}/email-templates`),
    item("Media", "media", "perm_media", `${base}/media`),
    item("Settings", "settings", "settings", `${base}/settings`),
  ];
};
